import API from "./API";

export default class Despesas extends API
{
    static async all() {
        return this.get("api/admin/expenses/list");
    }

    static async find(id) {
        return this.get("api/admin/expenses/" + id);
    }

    static async search(filter) {
        return this.get("api/admin/expenses",{params: filter});
    }

    static async create(params) {
        return this.post("api/admin/expenses", params);
    }

    static async update(params, id) {
        return this.post("api/admin/expenses/" + id, params);
    }

    static async getTypes() {
        return await this.get('api/admin/expenses/get-types');
    }
}